import DatePicker from '../datepicker/datepicker';
import { StatusQuestionnaire } from '../../types/data';

type ChoosingMonthProps = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  quarterIndex: number;
  setQuarterIndex: React.Dispatch<React.SetStateAction<number>>;
  statusQuestionnaire?: StatusQuestionnaire;
  currentDate: unknown;
  custom?: boolean;
};

function ChoosingMonth(props: ChoosingMonthProps) {
  const { year, setYear, quarterIndex, setQuarterIndex, statusQuestionnaire, currentDate, custom } = props;

  const getColor = (param: StatusQuestionnaire) => {
    if (param === 'Не начато') return '#8899A8';
    if (param === 'В процессе') return '#F2A900';
    if (param === 'Завершено') return '#22AD5C';
  };

  return (
    <div className="flex grow justify-center gap-4 rounded-md bg-white p-4 shadow-md">
      <DatePicker
        year={year}
        setYear={setYear}
        quarterIndex={quarterIndex}
        setQuarterIndex={setQuarterIndex}
        isSummary={custom as boolean}
        currentDate={currentDate}
      />

      {!custom && statusQuestionnaire && (
        <div className="flex items-center gap-2">
          <div className='h-2 w-2 rounded-full' style={{backgroundColor: getColor(statusQuestionnaire)}} />
          <div style={{color: getColor(statusQuestionnaire)}}>{statusQuestionnaire}</div>
        </div>
      )}
    </div>
  );
}

export default ChoosingMonth;
